module.exports = __webpack_public_path__ + "img/carte_CIB.07e92548.jpg";